import { render, staticRenderFns } from "./GoodsClaim.vue?vue&type=template&id=027aca78&scoped=true"
import script from "./GoodsClaim.vue?vue&type=script&lang=js"
export * from "./GoodsClaim.vue?vue&type=script&lang=js"
import style0 from "./GoodsClaim.vue?vue&type=style&index=0&id=027aca78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027aca78",
  null
  
)

export default component.exports